<template>
  <div class="container-fluid">
    <Card>
      <template slot="header">
        <h3>پیش فاکتورها</h3>
      </template>
      <template slot="content">
        <CustomerTempFactor :key="keyrender" :CustomerId="$session.get('CustomerInfo').Id" :TempFactorList="TempFactorList"></CustomerTempFactor>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import CustomerTempFactor from '../../UserMenu/Components/CustomerTempFactor.vue'

export default {
  data() {
    return {
      TempFactorList: [],
      keyrender: 1,
    }
  },
  components: { Card, CustomerTempFactor },
  methods: {
    GetCustomerTempFactors() {
      var DataAxios = {
        Action: 'TempFactor/GetCustomerTempFactor',
        Method: 'POST',
        ArryfildValue: { Id: this.$session.get('CustomerInfo').Id },
      }
      this.$PostData(DataAxios).then((result) => {
        this.TempFactorList = result
        this.keyrender++
      })
    },
  },
  created() {
    this.GetCustomerTempFactors()
  },
}
</script>
